{
    "AutoMtdIssue": "0",
    "AutoMtdQte": "0",
    "AutoPr3MtdIssue": "0",
    "AutoPr3MtdQte": "0",
    "AutoRolling12Issue": "0",
    "AutoRolling12Qte": "0",
    "AutoTicketsAccidents": "0",
    "AutoYtdIssue": "0",
    "AutoYtdQte": "0",
    "AverageCreditDecileIssues": "0",
    "AverageCreditDecileQuotes": "0",
    "AverageTenureWithPriorCarrier": "0",
    "AverageVehicleCount": "0",
    "BridgeCount": "0",
    "Channel": "",
    "CondoMtdIssueCnt": "0",
    "CondoMtdQteCnt": "0",
    "CondoPr3IssueCnt": "0",
    "CondoPr3QteCnt": "0",
    "CondoRolling12IssueCnt": "0",
    "CondoRolling12QteCnt": "0",
    "CondoYtdIssueCnt": "0",
    "CondoYtdQteCnt": "0",
    "HighCovLvlQtePct": "0",
    "HomeMtdIssue": "0",
    "HomeMtdQte": "0",
    "HomePr3MtdIssue": "0",
    "HomePr3MtdQte": "0",
    "HomeRolling12Issue": "0",
    "HomeRolling12Qte": "0",
    "HomeYtdIssue": "0",
    "HomeYtdQte": "0",
    "LandlordMtdIssueCnt": "0",
    "LandlordMtdQteCnt": "0",
    "LandlordPr3IssueCnt": "0",
    "LandlordPr3QteCnt": "0",
    "LandlordRolling12IssueCnt": "0",
    "LandlordRolling12QteCnt": "0",
    "LandlordYtdIssueCnt": "0",
    "LandlordYtdQteCnt": "0",
    "LastIssueDate": "",
    "LastQuoteDate": "",
    "LowCovLvlQtePct": "0",
    "MotorcycleMtdIssueCnt": "0",
    "MotorcycleMtdQteCnt": "0",
    "MotorcyclePr3IssueCnt": "0",
    "MotorcyclePr3QteCnt": "0",
    "MotorcycleRolling12IssueCnt": "0",
    "MotorcycleRolling12QteCnt": "0",
    "MotorcycleYtdIssueCnt": "0",
    "MotorcycleYtdQteCnt": "0",
    "MultiLocInd": "",
    "MultiStateInd": "",
    "PctOfAutoQuotesBiLimits100300": "0",
    "PctOfAutosWithViolationFreeDiscount": "0",
    "PctOfHomesWithServiceLineCyberEnd": "0",
    "PctQuotesWithNhns": "0",
    "PolEsignCmpltPct": "0",
    "PolEsignPndng": "0",
    "PrimaryLoc": "",
    "PrimaryRater": "",
    "PrimaryState": "",
    "PriSubstat": "",
    "RentersMtdIssueCnt": "0",
    "RentersMtdQteCnt": "0",
    "RentersPr3IssueCnt": "0",
    "RentersPr3QteCnt": "0",
    "RentersRolling12IssueCnt": "0",
    "RentersRolling12QteCnt": "0",
    "RentersYtdIssueCnt": "0",
    "RentersYtdQteCnt": "0",
    "RtCnt": "0",
    "RtPct": "0",
    "SpcMtdIssue": "0",
    "SpcMtdQte": "0",
    "SpcPr3MtdIssue": "0",
    "SpcPr3MtdQte": "0",
    "SpcRolling12Issue": "0",
    "SpcRolling12Qte": "0",
    "SpcYtdIssue": "0",
    "SpcYtdQte": "0",
    "UmbrellaMtdIssueCnt": "0",
    "UmbrellaMtdQteCnt": "0",
    "UmbrellaPr3IssueCnt": "0",
    "UmbrellaPr3QteCnt": "0",
    "UmbrellaRolling12IssueCnt": "0",
    "UmbrellaRolling12QteCnt": "0",
    "UmbrellaYtdIssueCnt": "0",
    "UmbrellaYtdQteCnt": "0",
    "UserID": "",
    "WatercraftMtdIssueCnt": "0",
    "WatercraftMtdQteCnt": "0",
    "WatercraftPr3IssueCnt": "0",
    "WatercraftPr3QteCnt": "0",
    "WatercraftRolling12IssueCnt": "0",
    "WatercraftRolling12QteCnt": "0",
    "WatercraftYtdIssueCnt": "0",
    "WatercraftYtdQteCnt": "0"
}